import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import { env } from '@ivy/fts/envInfo/envInfo';
let CouponListPopup = class CouponListPopup extends Vue {
    constructor() {
        super(...arguments);
        this.coupons = [];
    }
    get popupVisible() {
        return this.visible;
    }
    get giftFilter() {
        return ((this.giftList && this.giftList.length && this.giftList) ||
            this.curLevel.gifts).filter(i => i.isShoWGift);
    }
    async created() {
        // await this.$store.login()
        let r = (this.giftList && this.giftList.length && this.giftList) ||
            this.curLevel.gifts;
        await env.init();
    }
    hide() {
        this.close();
    }
    jumpLink(gift) {
        if (['vip', 'coupon'].includes(gift.virtual_type) ||
            gift.is_gift_can_jump === 0 ||
            !gift.is_gift_can_jump ||
            !gift.gift_jump_link) {
            return;
        }
        else {
            return (window.location.href = gift.gift_jump_link);
        }
    }
};
tslib_1.__decorate([
    Prop()
], CouponListPopup.prototype, "visible", void 0);
tslib_1.__decorate([
    Prop()
], CouponListPopup.prototype, "close", void 0);
tslib_1.__decorate([
    Prop()
], CouponListPopup.prototype, "curLevel", void 0);
tslib_1.__decorate([
    Prop()
], CouponListPopup.prototype, "giftList", void 0);
CouponListPopup = tslib_1.__decorate([
    Component({})
], CouponListPopup);
export default CouponListPopup;
